import { DefaultTheme } from 'styled-components';

import grid from './grid/grid';
import getTypography from './typography/typography';
import elevations from './elevations/elevations';
import colors from './colors/colors';
import breakpoints from './breakpoints/breakpoints';

export const TucarTheme: DefaultTheme = {
  name: 'light-theme',
  colors: {
    ...colors,
  },
  breakpoints,
  grid,
  typography: getTypography(),
  elevations,
};
